import { render, staticRenderFns } from "./FinancialRecords.vue?vue&type=template&id=9f5372dc&scoped=true"
import script from "./FinancialRecords.vue?vue&type=script&lang=js"
export * from "./FinancialRecords.vue?vue&type=script&lang=js"
import style0 from "./FinancialRecords.vue?vue&type=style&index=0&id=9f5372dc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f5372dc",
  null
  
)

export default component.exports